import {m} from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

const pathVariants = {
    hidden: {
        pathLength: 0,
    },
    visible: {
        pathLength: 1,
        transition: {
            duration: 0.8,
            ease: 'easeInOut',
        },
    },
}

interface SvgOutlineProps {
    animationControls: object
}

const SvgOutline = ({animationControls}: SvgOutlineProps) => {
    return (
        <SvgElement
            width="183"
            height="120"
            viewBox="0 0 183 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <SvgPath
                as={m.path}
                d="M143.325 28.6029C141.386 20.4271 131.342 17.9527 124.054 16.9111C91.0677 12.1965 52.6064 19.6963 25.2126 38.923C15.7227 45.5835 2.53318 60.0825 9.98597 72.8623C16.0087 83.1898 30.3356 87.7209 40.8923 90.9535C59.3572 96.6078 78.8432 98.6903 98.0799 98.7959C112.27 98.8738 126.468 97.769 140.287 94.398C151.101 91.7603 163.049 87.6684 170.434 78.7674C180.661 66.442 176.061 48.4706 167.6 36.7158C161.874 28.7602 150.569 18.1523 140.811 15.3664"
                variants={pathVariants}
                initial="hidden"
                animate={animationControls}
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </SvgElement>
    )
}

const SvgElement = styled.svg`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
`

const SvgPath = styled.path`
    stroke-width: 2px;
`

export default SvgOutline
